import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type MapBounds = [YMaps.TCoord, YMaps.TCoord];
export type MapCenter = YMaps.TCoord;

export type MapConfigurationState = {
  initialized: boolean;
  center: MapCenter;
  zoom: number;
  bounds: MapBounds;
  drawMode: boolean;
};

const mapConfigurationInitialState = {
  initialized: false,
  drawMode: false,
} as MapConfigurationState;

export const mapConfiguartionSlice = createSlice({
  initialState: mapConfigurationInitialState,
  name: 'mapConfiguration',
  reducers: {
    setMapInitialState(
      state,
      action: PayloadAction<Omit<MapConfigurationState, 'initialized' | 'bounds' | 'drawMode'>>,
    ) {
      state.center = action.payload.center;
      state.zoom = action.payload.zoom;
    },
    setMapConfiguration(state, action: PayloadAction<Omit<MapConfigurationState, 'initialized' | 'drawMode'>>) {
      state.bounds = action.payload.bounds;
      state.center = action.payload.center;
      state.zoom = action.payload.zoom;
    },
    setMapInitialized: state => {
      state.initialized = true;
    },
    setDrawMode: (state, action: PayloadAction<boolean>) => {
      state.drawMode = action.payload;
    },
  },
});

export const { reducer: mapConfigurationReducer, actions: mapConfigurationActions } = mapConfiguartionSlice;
